import React, {useState, useEffect} from 'react'
import classes from '../css/Header.module.css'
import { NavText } from '../NavElements'
import styled from 'styled-components'
import {FiMenu, FiX, FiHome, FiFileText, FiEdit, FiUser} from 'react-icons/fi'
import { Logo } from '../Logo/Logo'

interface SideHeaderProps {
    active?: boolean,
    color?: string
  }
  

  const SideBtn = styled.div`
    display: flex; 
    right: 30px; 
    position: absolute;
    z-index: 6;
    padding: 5px;
    border-radius: 5px;
    transition: background-color 0.2s ease;
    &:hover{
      background-color: gray;
    }
`

export const SideHeader: React.FC<SideHeaderProps> = (props)=>{
  
       const [show, setShow] = useState(false)
       
      const _onClick = ()=>{
        setShow(!show)
      }
  
      useEffect(()=>{
           if(show)
             document.body.classList.add(classes.stopscroll)
          else
             document.body.classList.remove(classes.stopscroll)

          return ()=>document.body.classList.remove(classes.stopscroll)
       },[show])
  
    return (
      <header style = {{
        width: '100%',
        height: 90,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: props.color ?  props.color : props.active ? '#12171d' : 'rgba(0,0,0,0)',
        position: 'fixed',
        zIndex: 99
      }}>
      <NavText style={{textAlign: 'center', alignSelf: 'center'}} to='/'><Logo /></NavText>
      <SideBtn onClick={()=>setShow(!show)}>
        {show ? <FiX size={30} color='#fff' />: <FiMenu size={30} color='#fff' />}
      </SideBtn>
 
      <>
      {show && <div onClick={_onClick} style={{display: 'block', top: 0, width: '100%', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', position: 'absolute',zIndex: 3, overflow: 'hidden'}}/>}
      <div style={show ? {...containerStyle, ...openAni} : containerStyle}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 10}}><Logo /></div>
        <NavText style={NavTextStyle} to='/' onClick={()=>setShow(false)}>
          <FiHome size={26} color='#BBBBBB'/>
          <p style={{textAlign: 'right'}}>الرئيسية</p>
          </NavText>
        <NavText style={NavTextStyle} to='/jobs' onClick={()=>setShow(false)}>
          <FiFileText size={26} color='#BBBBBB'/>
          <p>جميع الوظائف</p>
          </NavText>
        {/*<NavText style={NavTextStyle} to='/jobs' onClick={()=>setShow(false)}>*/}
        {/*  <FiFileText size={26} color='#BBBBBB'/>*/}
        {/*  <p>وظائف/تدريبات للطلبة</p>*/}
        {/*  </NavText>*/}
        <NavText style={NavTextStyle} to='/jobs/graduates' onClick={()=>setShow(false)}>
          <FiFileText size={26} color='#BBBBBB'/>
          <p>وظائف للخريجين</p>
          </NavText>
        <NavText style={NavTextStyle} to='/register' onClick={()=>setShow(false)}>
          <FiEdit size={26} color='#BBBBBB' />
          <p style={{textAlign: 'center'}}>التسجيل</p>
        </NavText>
        <NavText style={NavTextStyle} to='/login' onClick={()=>setShow(false)}>
          <FiUser size={26} color='#BBBBBB' />
          <p style={{textAlign: 'center'}}>تسجيل دخول</p>
        </NavText>
      </div>
      </>
      </header>
    )
  } 

  
const NavTextStyle: React.CSSProperties = {
    backgroundColor: '#1D252D', 
    borderBottom: '1px solid rgba(255,255,255,0.3)', 
    display: 'flex',
    height:'65px',
    alignItems: 'center', 
    justifyContent: 'space-between', 
    paddingLeft: 15, 
    paddingRight: 40
  }
  
  const containerStyle: React.CSSProperties = {
    position: 'absolute', 
    width: '70%', 
    height: '100vh', 
    backgroundColor: '#1D252D', 
    right: 0, 
    top: 0,
    paddingTop: 70, 
    zIndex: 5,
    transform: 'translateX(100%)',
    transition: 'transform 0.3s ease-in-out'
  }

  const openAni: React.CSSProperties = {
    transform: 'translateX(0%)',
  }